<template>
    <v-container fluid sm-pa-0 md-pa-3>
        <v-layout mb-3>
            <v-flex sm12>
                <v-card color="grey lighten-3">
                    <v-card-title primary-title>
                        <h3 class="headline mb-0">Techlab: Chatbot</h3> <br />
                    </v-card-title>

                    <v-card-text>

                        Nachfolgender Demo-Bot wurde mit DialogFlow implementiert. Der Bot kann einfache Fragen beantworten,
                        z.B: "Wie alt bist Du?" oder "Wer hat Dich programmiert?"  Einige Intents sind noch 
                        nicht imlementiert;
                        in diesem Fall wird als Antwort nur der erkannte Intent angezeigt.
                        Im zweiten Fenster sehen Sie die JSON Response zum Rest Call an das Dialogflow API.

                        Wir sind bei der Potentialanalyse von BotSystemen gerne behilflich.
                    </v-card-text>

                    <!-- Not needed now
                    <v-card-actions>
                        <v-btn flat color="orange">Share</v-btn>
                        <v-btn flat color="orange">Explore</v-btn>
                    </v-card-actions>
                        -->
                </v-card>
            </v-flex>
        </v-layout> <!-- text zeile -->


        <v-layout row wrap>
            <v-flex xs12 md6>

                <CoBot :messageList='messageList'
                         v-on:send-message="sendMessage">

                </CoBot>
                {{ uiBotMessage }}
            </v-flex>

            <v-flex xs12 md6 sm-pl-0 pl-2 mt-2 mb-3>
                <span class="title">Json Antwort von Dialogflow</span>
                <pre style="width:100%; margin-top:10px;  background-color:lightgray">{{uiResponse}}</pre>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>

    import axios from 'axios';
    import CoBot from './CoBot.vue';

    export default {
        components: {
            CoBot
        },

        props: {
            lang: {
                type: String,
                default: 'de-de'
            }
        },

        data: () => ({

            uiBotMessage: "",
            uiResponse: "",
            messageList: [],

        }),




        methods: {


            sendMessage(text) {
                // Process the chatmessage in the store
                console.log("Message : " + JSON.stringify(text));


                // Do not process empty text.
                if (text === "") return;

                let message = this.createMessage('me', text);

                this.$store
                    .dispatch({
                        type: 'sendChatMessage', // <--- name der Action, der Rest des Objekte is payload
                        chatType: this.name,
                        text: text
                    })
                    .then(result => {
                        console.log("Store returned : " + result.code);
                        this.sendToDialogFlow(message.data.text);
                    })
                    .catch(error => {
                        console.log("Action FAILED" + error);
                    });

                // called when the user sends a message
                this.messageList = [...this.messageList, message]
            },


            createMessage(author, text) {

                let result = {
                    author: author,
                    type: 'text',
                    data: {
                        text: text
                    },

                    timestamp: Date.now()
                };


                return result;
            },

            sendToDialogFlow(chatText) {
                this.hFullResponse = "<reset>";
                console.log("sendToDialogFlow : " + chatText);


                //Greipl24
                const accessToken = "5d6a6a1b7ced49d4b7501376a7ca2905";

                let url = 'https://api.api.ai/v1/query?v=20150910';
                let config = {
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': "Bearer " + accessToken
                    }
                };

                let data = JSON.stringify({
                    query: chatText,
                    lang: "de",
                    sessionId: "2",
                });

                axios.post(url, data, config)
                    .then(
                        R => {

                            // Das Token rausnehmen
                            R.config.headers.Authorization = "Bearer *****";
                            this.uiResponse =R;
                            //  console.log("Response : " + prettyFormat(R));


                            //let response = R.data.result.fulfillment.messages[0].speech;

                            let intent = R.data.result.metadata.intentName;
                            let response = this.processIntent(intent);

                            this.uiBotMessage = "Intent: " + intent;

                            console.log("Intent / Response : " + intent + "/" + response);

                            this.messageList.push(this.createMessage("Bot", response));

                        })
                    .catch(error => {
                        console.log("Error : " + JSON.stringify(error));

                    });

            },

            // Manual processing of intent. Move this to server...
            processIntent(intent) {

                let defaultResponse = "Unhandled Intent: " + intent;
                let response = [defaultResponse];

                console.log("processIntent");

                switch (intent) {
                    case 'Default Fallback Intent':
                        response = ["Das habe ich nicht verstanden..."];
                        return response[0];

                    case 'smalltalk.agent.acquaintance':
                        response = ["Ich bin eine Demo und kann etwas smalltalk"];
                        return response[0];


                    case 'smalltalk.agent.age':
                        response = ["Ich wurde im Januar 2019 von Prof. Greipl programmiert."];
                        return response[0];

                    case 'smalltalk.agent.annoying':
                        response = ["Sorry, schade. Was ist los?"];
                        return response[0];

                    case 'smalltalk.agent.answer_my_question':
                        response = ["Ich finde leide keine gute Antwort!"];
                        return response[0];

                    case 'smalltalk.agent.bad':
                        response = ["Ja, ich bin eine Demo und ich kann nur Smalltalk!"];
                        return response[0];

                    case 'smalltalk.agent.be_clever':
                        response = ["Ich bemühe mich, aber mehr ist nicht drin"];
                        return response[0];

                    case 'smalltalk.agent.beautiful':
                        response = ["Danke für das Kompliment"];
                        return response[0];

                    case 'smalltalk.agent.birthdate':
                        response = ["Ich bin seit dem 15.1.2019 aktiv"];
                        return response[0];

                    case 'smalltalk.agent.boring':
                        response = ["Sei nicht so streng mit mir!"];
                        return response[0];

                    case 'smalltalk.agent.boss':
                        response = ["Mein Boss ist Prof. Greipl. Du erreichst ihn auf Skype unter dgreipl."];
                        return response[0];

                    case 'smalltalk.agent.busy':
                        response = ["Hmm, heute ist viel los hier"];
                        return response[0];

                    case 'smalltalk.agent.can_you_help':
                        response = ["Wie kann ich helfen?"];
                        return response[0];

                    case 'smalltalk.agent.chatbot':
                        response = ["Ich bin ein Chatbot und kein Mensch."];
                        return response[0];

                    case 'smalltalk.agent.clever':
                        response = ["Danke! Ich kann aber noch recht wenig..."];
                        return response[0];

                    case 'smalltalk.agent.crazy':
                        response = ["Echt?"];
                        return response[0];

                    case 'smalltalk.agent.date_user':
                        response = ["Hmm, ich bin nicht so flexibel. Wir k�nnen uns nur hier treffen."];
                        return response[0];

                    case 'smalltalk.agent.drunk':
                        response = ["Ach komm, ich trinke nicht."];
                        return response[0];

                    case 'smalltalk.agent.family':
                        response = ["Ich habe noch keine Familie. Willst Du mich adoptieren?"];
                        return response[0];

                    case 'smalltalk.agent.fired':
                        response = ["Schade, ich habe mich so angestrengt. Bye."];
                        return response[0];

                    // Seite 2
                    case 'smalltalk.agent.funny':
                        response = ["Freut mich, wenn Du lachst!"];
                        return response[0];

                    case 'smalltalk.agent.happy':
                        response = ["Ja, mir geht es recht gut!"];
                        return response[0];

                    case 'smalltalk.agent.hobby':
                        response = ["Schwer zu sagen, eigentlich habe ich keien Hobbies."];
                        return response[0];

                    case 'smalltalk.agent.hungry':
                        response = ["Nein, ich habe keinen Hunger."];
                        return response[0];

                    case 'smalltalk.agent.marry_user':
                        response = ["Oh Gott, so schnell?"];
                        return response[0];

                    case 'smalltalk.agent.my_friend':
                        response = ["Für immer!"];
                        return response[0];

                   

                    default:
                        return response[0];
                }
            },



        },

        mounted() {        
            this.messageList.push(this.createMessage("Bot", "Wie kann ich helfen?"));
        },
    }
</script>